/* @flow */

// $FlowFixMe
module.exports = require('./dist/braintree-paypal-client-config'); // eslint-disable-line import/no-commonjs



// WEBPACK FOOTER //
// ./node_modules/braintree-paypal-client-config/index.js